import "./style.scss";
import PropTypes from "prop-types";
import { logOut } from "utils/helper";
import IdleTimer from "utils/idleTimer";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { DashboardNavbar, Sidebar } from "components";

const DashboardLayout = (props) => {
  const { children, fullWidth } = props;

  const [openSidebar, setOpenSidebar] = useState(false);

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 992);

  const width = window.innerWidth;

  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    const updateWindowDimensions = () => {
      if (window.innerWidth < 992) {
        setIsSmallScreen(true);
      } else {
        setIsSmallScreen(false);
      }
    };
    window.addEventListener("resize", updateWindowDimensions);
  }, [width, isSmallScreen]);

  const shouldOpenSidebar = isSmallScreen ? openSidebar : true;

  useEffect(() => {
    const timer = new IdleTimer({
      timeout: user.session_timeout,
      onTimeout: () => {
        logOut();
      },
    });

    return () => {
      timer.cleanUp();
    };
  }, [user.session_timeout]);

  return (
    <div>
      <DashboardNavbar handleSidebarOpen={() => setOpenSidebar(true)} />

      <Sidebar
        handleSidebarClose={() => setOpenSidebar(false)}
        open={shouldOpenSidebar}
        isSmallScreen={isSmallScreen}
      />

      <div
        className={`dashboard-main ${
          fullWidth ? "dashboard-main--full-width" : ""
        }`}
      >
        {children}
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
export default DashboardLayout;
